<template >
  <base-material-card color="secondary" class="mx-10" icon="mdi-cog-outline">
    <template v-slot:after-heading>
      <div class="display-1 mt-2 font-weight-light">
        {{ $t("admin_panel") }}
      </div>
    </template>
    <v-layout>
      <v-tabs
        v-model="tabs"
        background-color="transparent"
        color="secondary"
        show-arrows
        slider-color="secondary"
      >
        <v-tab class="mr-3" v-if="RBAC_system_VIEW_PERFORMANCE">
          <v-icon class="mr-2">mdi-chart-bar</v-icon>
          {{ $t("performance") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_system_VIEW_SYSTEM">
          <v-icon class="mr-2">mdi-monitor</v-icon>
          {{ $t("system_info") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_system_VIEW_LOGS">
          <v-icon class="mr-2">mdi-account-arrow-right-outline</v-icon>
          {{ $t("logs") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_pagamenti_EDIT_PAGAMENTI">
          <v-icon class="mr-2">mdi-cash-register</v-icon>
          {{ $t("edit_payment") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_EDIT_SETTINGS">
          <v-icon class="mr-2">mdi-book-outline</v-icon>
          {{ $t("edit_causali") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_tesseramenti_EDIT_TESSERE">
          <v-icon class="mr-2">mdi-credit-card-multiple-outline</v-icon>
          {{ $t("registry_affiliation_card") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_EDIT_SETTINGS">
          <v-icon class="mr-2">mdi-file-tree</v-icon>
          {{ $t("edit_pdc") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_EDIT_SETTINGS">
          <v-icon class="mr-2">mdi-account-key-outline</v-icon>
          {{ $t("edit_cdx") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_contab_RENUMERATE_CGE">
          <v-icon class="mr-2">mdi-tune-vertical</v-icon>
          {{ $t("renumerate_protocol") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_configuration_VIEW_CONFIGURATION">
          <v-icon class="mr-2">mdi-help-circle</v-icon>
          {{ $t("help_guide") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_role_EDIT_ROLE && RBAC_role_GRANT_ROLE">
          <v-icon class="mr-2">mdi-key-outline</v-icon>
          {{ $t("edit_roles") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_role_GRANT_ROLE">
          <v-icon class="mr-2">mdi-account-key-outline</v-icon>
          {{ $t("edit_user_role") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_configuration_VIEW_CONFIGURATION">
          <v-icon class="mr-2">mdi-tune-vertical</v-icon>
          {{ $t("configuration_parameter") }}
        </v-tab>
        <v-tab class="mr-3">
          <v-icon class="mr-2">mdi-router-network-wireless</v-icon>
          {{ $t("manage_service_account") }}
        </v-tab>
        <v-tab class="mr-3" v-if="RBAC_role_CAN_IMPERSONATE">
          <v-icon class="mr-2">mdi-account-arrow-right-outline</v-icon>
          {{ $t("impersonate_user") }}
        </v-tab>
        
      </v-tabs>
    </v-layout>

    <v-tabs-items v-model="tabs" class="transparent tabs-container">
      <v-tab-item v-if="RBAC_system_VIEW_PERFORMANCE">
        <performance />
      </v-tab-item>
      <v-tab-item v-if="RBAC_system_VIEW_SYSTEM">
        <system-info :showLicenses="true" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_system_VIEW_LOGS">
        <view-logs :card="false" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_pagamenti_EDIT_PAGAMENTI">
        <list-payments />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_EDIT_SETTINGS">
        <list-causali />
      </v-tab-item>
      <v-tab-item v-if="RBAC_tesseramenti_EDIT_TESSERE">
        <list-tessere :card="false" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_EDIT_SETTINGS">
        <gest-pdc :card="false" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_EDIT_SETTINGS">
        <list-cdx />
      </v-tab-item>
      <v-tab-item v-if="RBAC_contab_RENUMERATE_CGE">
        <rinumera-protocolli />
      </v-tab-item>
      <v-tab-item v-if="RBAC_configuration_VIEW_CONFIGURATION">
        <edit-help />
      </v-tab-item>
      <v-tab-item v-if="RBAC_role_EDIT_ROLE && RBAC_role_GRANT_ROLE">
        <edit-role :card="false" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_role_GRANT_ROLE">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="masterId"
                :items="selectUsers"
                item-text="text"
                item-value="value"
                dense
                :label="$t('select_user')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <edit-user-role :card="false" :masterId="masterId" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item v-if="RBAC_configuration_VIEW_CONFIGURATION">
        <edit-configuration :card="false" />
      </v-tab-item>
      <v-tab-item v-if="RBAC_system_ADMIN_SYSTEM">
        <manage-service-account />
      </v-tab-item>
      <v-tab-item v-if="RBAC_role_CAN_IMPERSONATE">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="masterId"
                :items="selectUsers"
                item-text="text"
                item-value="value"
                dense
                :label="$t('select_user')"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <impersonate :masterId="masterId" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
  </base-material-card>
</template>
<script>
import impersonate from "@/app/admin/impersonate.vue";
import viewLogs from "@/app/admin/viewLogs.vue";
import performance from "@/app/admin/performance.vue";
import listPayments from "@/app/admin/listPayments.vue";
import listTessere from "@/app/tessere/listTessere.vue";
import editRole from "@/app/admin/editRole.vue";
import deployInstance from "@/app/admin/deployInstance.vue";
import editConfiguration from "@/app/admin/editConfiguration.vue";
import systemInfo from "@/app/admin/systemInfo.vue";
import editUserRole from "@/app/admin/editUserRole.vue";
import editHelp from "@/app/admin/editHelp.vue";
import manageServiceAccount from "@/app/admin/manageServiceAccount.vue";
import listCausali from "@/app/contab/listCausali.vue";
import rinumeraProtocolli from "@/app/contab/rinumeraProtocolli.vue";
import listCdx from "@/app/contab/listCdx.vue";
import gestPdc from "@/app/contab/gestPdc.vue";

export default {
  name: "admin-panel",
  components: {
    impersonate: impersonate,
    "edit-role": editRole,
    "view-logs": viewLogs,
    performance: performance,
    "list-payments": listPayments,
    "list-tessere": listTessere,
    "deploy-instance": deployInstance,
    "edit-configuration": editConfiguration,
    "system-info": systemInfo,
    "edit-user-role": editUserRole,
    "edit-help": editHelp,
    "manage-service-account": manageServiceAccount,
    "list-causali": listCausali,
    "list-cdx": listCdx,
    "gest-pdc": gestPdc,
    "rinumera-protocolli": rinumeraProtocolli,
  },
  data() {
    return {
      tabs: 0,
      masterId: null,
      selectUsers: [],
      RBAC_pagamenti_EDIT_PAGAMENTI: false,
      RBAC_system_VIEW_SYSTEM: false,
      RBAC_system_VIEW_PERFORMANCE: false,
      RBAC_system_VIEW_LOGS: false,
      RBAC_system_ADMIN_SYSTEM: false,
      RBAC_role_GRANT_ROLE: false,
      RBAC_role_EDIT_ROLE: false,
      RBAC_tesseramenti_EDIT_TESSERE: false,
      RBAC_role_CAN_IMPERSONATE: false,
      RBAC_configuration_VIEW_CONFIGURATION: false,
      RBAC_contab_EDIT_SETTINGS: false,
      RBAC_contab_RENUMERATE_CGE: false,
    };
  },
  methods: {},
  created() {
    let _ = this;
    _.RBAC_pagamenti_EDIT_PAGAMENTI = _.checkUserRole(
      "pagamenti",
      "EDIT_PAGAMENTI"
    );
    _.RBAC_system_VIEW_SYSTEM = _.checkUserRole("system", "VIEW_SYSTEM");
    _.RBAC_system_ADMIN_SYSTEM = _.checkUserRole("system", "ADMIN_SYSTEM");
    _.RBAC_system_VIEW_PERFORMANCE = _.checkUserRole(
      "system",
      "VIEW_PERFORMANCE"
    );
    _.RBAC_system_VIEW_LOGS = _.checkUserRole("system", "VIEW_LOGS");
    _.RBAC_role_GRANT_ROLE = _.checkUserRole("role", "GRANT_ROLE");
    _.RBAC_role_EDIT_ROLE = _.checkUserRole("role", "EDIT_ROLE");
    _.RBAC_contab_EDIT_SETTINGS = _.checkUserRole("contab", "EDIT_SETTINGS");
    _.RBAC_contab_RENUMERATE_CGE = _.checkUserRole("contab", "RENUMERATE_CGE");
    _.RBAC_tesseramenti_EDIT_TESSERE = _.checkUserRole(
      "tesseramenti",
      "EDIT_TESSERE"
    );
    _.RBAC_role_CAN_IMPERSONATE = _.checkUserRole("role", "CAN_IMPERSONATE");
    _.RBAC_configuration_VIEW_CONFIGURATION = _.checkUserRole(
      "configuration",
      "VIEW_CONFIGURATION"
    );
    _.tabs = parseInt(_.$route.query.tab, 10) || 0;
    _.selectUsers = [];
    _.chiamataAxios("POST", "/auth/portal/listUsers", {
      body: { filter: {} },
    }).then((response) => {
      _.masterId = window.myData.masterId;
      _.selectUsers = response.data.map(function (item) {
        return {
          value: item.masterId,
          text:
            item.surname +
            " " +
            item.name +
            "   -   " +
            item.resCity +
            " (" +
            item.eta +
            " anni)",
        };
      });
    });
  },
  watch: {
    tabs(value) {
      // mantiene la tab corrente nell'URL per sopravvivere al reload della pagina
      this.$router
        .replace({ query: { ...this.$route.query, tab: value } })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") throw err;
        });
    },
  },
};
</script>
